<template>
  <q-dialog v-model="modal.show"
            @keydown.escape="close"
            persistent
            transition-show="scale"
            transition-hide="scale">
    <q-card style="width: 320px">
      <q-form @submit.prevent.stop="save" :disabled="loading">
        <q-card-section>
          <div class="text-h6" v-if="modal.id">Update price alert</div>
          <div class="text-h6" v-else>Create price alert</div>
        </q-card-section>

        <q-separator/>

        <div v-if="fetching">
          <q-card-section class="q-pa-md">
            <loading></loading>
          </q-card-section>
        </div>

        <q-card-section v-else>
          <div>
            <q-select
              color="grey-7"
              label-color="grey-7"
              label="Period"
              :options="priceAlertPeriodTypes()"
              v-model="selectedPeriodType"
              emit-value
              map-options
              lazy-rules
              autofocus
              clearable
              :error="errors.period_type !== null"
              :error-message="errors.period_type">
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div>
          <q-input label="% value change"
                   type="number"
                   step="any"
                   v-model="value"
                   @keydown.enter.prevent="save"
                   :error="errors.value !== null"
                   :error-message="errors.value"></q-input>
          </div>
          <div>
            <q-toggle v-model="decrease"
                      checked-icon="fas fa-arrow-down"
                      unchecked-icon="fas fa-arrow-up"
                      color="red"
                      :label="decrease ? 'Decrease price alert' : 'Increase price alert'"
                      :error="errors.change_type !== null"
                      :error-message="errors.change_type"/>
          </div>
        </q-card-section>

        <q-separator/>

        <q-card-actions align="right">
            <q-btn label="CLOSE" color="secondary" v-close-popup class="q-mr-sm" :disable="loading"/>
            <q-btn type="submit" label="SAVE" color="primary" :disable="loading || fetching"/>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
import {priceAlertPeriodTypes, getPriceAlertPeriodTypeByValue, getPriceAlertChangeTypeByValue} from "@/enums";
import Loading from "@/components/Loading.vue";

export default {
  name: 'AlertModal',
  components: {Loading},
  data() {
    return {
      fetching: true,
      loading: false,
      selectedPeriodType: null,
      selectedChangeType: null,
      value: null,
      decrease: false,
      errors: {
        type: null,
        value: null,
      }
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.state.priceAlert.modal;
      },
      set(val) {
        this.$store.commit('priceAlert/SET_MODAL', val);
      },
    },
    refreshRequired: {
      get() {
        return this.$store.state.priceAlert.refreshRequired;
      },
      set(val) {
        this.$store.commit('priceAlert/SET_REFRESH_REQUIRED', val);
      },
    }
  },
  methods: {
    priceAlertPeriodTypes() {
      return priceAlertPeriodTypes
    },
    async getAlert() {
      try {
        this.fetching = true;
        const {data} = await axios.get(`/price-alert/${this.modal.id}`)
        this.selectedPeriodType = getPriceAlertPeriodTypeByValue(data.data.period_type)?.value
        this.selectedChangeType = getPriceAlertChangeTypeByValue(data.data.change_type)?.value
        if (this.selectedChangeType === 'decrease') {
          this.decrease = true
        }
        this.value = data.data.value;
      } catch (e) {
        console.error(e);
        this.$q.notify({
          message: e.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.fetching = false;
      }
    },
    async save() {
      try {
        this.loading = true;
        if (this.decrease) {
          this.selectedChangeType = 'decrease'
        } else {
          this.selectedChangeType = 'increase'
        }
        const data = {
          period_type: this.selectedPeriodType,
          change_type: this.selectedChangeType,
          value: this.value
        }
        if (this.modal.id) {
          await axios.patch(`/price-alert/${this.modal.id}`, data);
        } else {
          await axios.put('/price-alerts', data);
        }
        this.refreshRequired = true
        this.close()
      } catch (e) {
        if (e.response.status < 500) {
          this.$q.notify({
            message: e.response.data.message,
            timeout: 250,
            position: 'top-right',
            progress: true,
            type: 'negative'
          })

          if (e.response.data.errors) {
            const errors = e.response.data.errors
            Object.keys(errors).map(key => {
              this.errors[key] = errors[key][0]
            })
          }
        } else {
          this.$q.notify({
            message: 'An error occurred while saving the alert.',
            timeout: 250,
            position: 'top-right',
            progress: true,
            type: 'negative'
          })
        }
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.selectedPeriodType = null
      this.selectedChangeType = null
      this.decrease = false
      this.value = null
      this.errors = {
        period_type: null,
        change_type: null,
        value: null,
      }
    },
    close() {
      this.loading = false
      this.fetching = false
      this.reset()
      this.modal = {show: false, id: null}
    }
  },
  watch: {
    modal: {
      async handler(val) {
        this.reset()
        if (val.show) {
          if (val.id) {
            await this.getAlert()
          }
          this.fetching = false
        }
      },
      deep: true
    }
  }
}
</script>
